/* Этот файл сгенерирован автоматически на основe шаблона exportService.hbs */
/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { VcsAudioEgressStartRequest } from '../models';
import type { VcsEgressStartRequest } from '../models';
import type { VcsEgressStartResponse } from '../models';
import type { VcsEgressStopRequest } from '../models';
import type { VcsEgressStopResponse } from '../models';
import { request } from 'api/apiRouter';
import type { ApiRequestOptions, ApiResponse } from '@web-chat-core/toolkit/src/api3';
export class VcsEgressExternalControllerV3Service {
    public static stopVideoEgress(
        workspaceId: number,
        requestBody: VcsEgressStopRequest,
        options?: ApiRequestOptions,
    ): Promise<ApiResponse<VcsEgressStopResponse>> {
        return request('meet', {
            ...options,
            method: 'POST',
            url: '/api/v3/vcs/external/egress/recording/video/stop',
            headers: {
                WorkspaceId: workspaceId,
                ...options?.headers,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `UNAUTHORIZED: accessToken is not valid.`,
                403: `Forbidden`,
            },
        });
    }
    public static startVideoEgress(
        workspaceId: number,
        requestBody: VcsEgressStartRequest,
        options?: ApiRequestOptions,
    ): Promise<ApiResponse<VcsEgressStartResponse>> {
        return request('meet', {
            ...options,
            method: 'POST',
            url: '/api/v3/vcs/external/egress/recording/video/start',
            headers: {
                WorkspaceId: workspaceId,
                ...options?.headers,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `UNAUTHORIZED: accessToken is not valid.`,
                403: `Forbidden`,
            },
        });
    }
    public static stopAudioEgress(
        workspaceId: number,
        requestBody: VcsEgressStopRequest,
        options?: ApiRequestOptions,
    ): Promise<ApiResponse<VcsEgressStopResponse>> {
        return request('meet', {
            ...options,
            method: 'POST',
            url: '/api/v3/vcs/external/egress/recording/audio/stop',
            headers: {
                WorkspaceId: workspaceId,
                ...options?.headers,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `UNAUTHORIZED: accessToken is not valid.`,
                403: `Forbidden`,
            },
        });
    }
    public static startAudioEgress(
        workspaceId: number,
        requestBody: VcsAudioEgressStartRequest,
        options?: ApiRequestOptions,
    ): Promise<ApiResponse<VcsEgressStartResponse>> {
        return request('meet', {
            ...options,
            method: 'POST',
            url: '/api/v3/vcs/external/egress/recording/audio/start',
            headers: {
                WorkspaceId: workspaceId,
                ...options?.headers,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `UNAUTHORIZED: accessToken is not valid.`,
                403: `Forbidden`,
            },
        });
    }
}
